import React, {useState, useEffect, useMemo} from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./serviceData.css";
import { ServiceHeading } from "./serviceDataComponent/serviceHeading";
import { ServiceCardThree } from "./serviceDataComponent/serviceCardThree";
import { baseUrl } from "../../../../../../network/constants/constants";
import config, { getConfig } from "../../../../../../network/auth";
import axios from "../../../../../../network/api";


export const ServiceData = ({ service_id }) => {
  const [detailservice, setDetailService] = useState(null); 
  const [loading, setLoading] = useState(false);


  const config = useMemo(() => {
    return getConfig()
  },[])

  const fetchServiceDetailsPage = () => {
    setLoading(true);
    axios
      .get(baseUrl + `businessadmin/service-details-page/${service_id}/`, config)
      .then((response) => {
        setLoading(false);
        setDetailService(response.data); 
      })
      .catch((error) => {
        console.error("Error fetching service details:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchServiceDetailsPage();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (!detailservice) return <div>No data available</div>; 

  return (
    <Container className="service-data-container">
      <Row>
        <Col>
          <ServiceHeading detailservice={detailservice} />
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className="service-card-one-two">
            <ServiceCardThree detailservice={detailservice} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};
